import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class JWTService {
  constructor() {}

  decodeToken(token: string) {
    //TODO: Implement logic to decode token
  }
}
